import { c as _c } from "react/compiler-runtime";
import { RoundupDriverGroupEnum } from '@repo/contracts/marketplace/offers/enums';
import { css, cx } from '@repo/pandacss/css';
import { Accordions } from '../Accordions';
import { HeaderBadges } from '../Badges';
import { offersPromotionalCopies } from '../constants';
import type { ProductCardProps } from '../types';
import { Content } from './Content';
import { ProductCardAnalyticsWrapper } from './ProductCardAnalyticsWrapper';
import { ProductCardSkeleton } from './Skeleton';
const styles = {
  productCard: css({
    position: 'initial',
    borderWidth: '[1px]',
    borderStyle: 'solid',
    borderColor: 'grey.200',
    borderRadius: 'md',
    mb: '3.5'
  }),
  productCardSpotlight: css({
    position: 'initial',
    borderWidth: '[2px]',
    borderStyle: 'solid',
    borderColor: 'greens.darkest',
    borderRadius: '[10px]',
    borderTopLeftRadius: '[0]',
    borderTopRightRadius: '[0]',
    mb: '3.5'
  }),
  productCardPadding: css({
    pl: '3',
    pr: '3',
    _pcMd: {
      pt: '2',
      pl: '3.5',
      pr: '3.5'
    }
  }),
  productCardEmbedded: css({
    borderWidth: '[0]',
    borderRadius: '[0]',
    mb: {
      base: '5',
      _pcMd: '[0]'
    }
  })
} as const;
export const ProductCard = t0 => {
  const $ = _c(37);
  const {
    additionalApplyNowProps,
    ctaAnalytics,
    creditCardOffer,
    driverGroup,
    initiallyExpandedAccordion,
    marketplacePayload,
    promotionalCopy,
    showSkeleton,
    skuViewedProps,
    shouldPrioritizeImage: t1,
    isLtoHighlightingEnabled: t2,
    trafficOriginType,
    hideOuterBorder: t3
  } = t0;
  const shouldPrioritizeImage = t1 === undefined ? false : t1;
  const isLtoHighlightingEnabled = t2 === undefined ? false : t2;
  const hideOuterBorder = t3 === undefined ? false : t3;
  const hydratedPromotionalCopy = promotionalCopy || offersPromotionalCopies[creditCardOffer.id];
  if (showSkeleton) {
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ProductCardSkeleton />;
      $[0] = t4;
    } else {
      t4 = $[0];
    }
    return t4;
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [RoundupDriverGroupEnum.Rewards, RoundupDriverGroupEnum.Subprime];
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const isRewardsOrSubprimeRU = t4.includes(driverGroup);
  const paddingClassName = styles.productCardPadding;
  const t5 = creditCardOffer.id;
  const t6 = hideOuterBorder && styles.productCardEmbedded;
  let t7;
  if ($[2] !== t6) {
    t7 = cx(styles.productCard, t6);
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== creditCardOffer.id || $[5] !== t7) {
    t8 = {
      id: t5,
      "data-testid": "product-card-redesign",
      className: t7
    };
    $[4] = creditCardOffer.id;
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== creditCardOffer.id || $[8] !== hydratedPromotionalCopy || $[9] !== isLtoHighlightingEnabled || $[10] !== isRewardsOrSubprimeRU) {
    t9 = <HeaderBadges offerId={creditCardOffer.id} promotionalCopy={hydratedPromotionalCopy} isRewardsOrSubprimeRU={isRewardsOrSubprimeRU} isLtoHighlightingEnabled={isLtoHighlightingEnabled} />;
    $[7] = creditCardOffer.id;
    $[8] = hydratedPromotionalCopy;
    $[9] = isLtoHighlightingEnabled;
    $[10] = isRewardsOrSubprimeRU;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const t10 = `product-card-${creditCardOffer.id}`;
  let t11;
  if ($[12] !== additionalApplyNowProps || $[13] !== creditCardOffer || $[14] !== ctaAnalytics || $[15] !== driverGroup || $[16] !== hydratedPromotionalCopy || $[17] !== isLtoHighlightingEnabled || $[18] !== marketplacePayload || $[19] !== shouldPrioritizeImage || $[20] !== trafficOriginType) {
    t11 = <Content additionalApplyNowProps={additionalApplyNowProps} creditCardOffer={creditCardOffer} ctaAnalytics={ctaAnalytics} driverGroup={driverGroup} marketplacePayload={marketplacePayload} promotionalCopy={hydratedPromotionalCopy} segmentActionSection="roundup_recommendations" trafficOriginType={trafficOriginType} shouldPrioritizeImage={shouldPrioritizeImage} isLtoHighlightingEnabled={isLtoHighlightingEnabled} />;
    $[12] = additionalApplyNowProps;
    $[13] = creditCardOffer;
    $[14] = ctaAnalytics;
    $[15] = driverGroup;
    $[16] = hydratedPromotionalCopy;
    $[17] = isLtoHighlightingEnabled;
    $[18] = marketplacePayload;
    $[19] = shouldPrioritizeImage;
    $[20] = trafficOriginType;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <div data-testid={t10}>{t11}</div>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t9) {
    t13 = <div className={paddingClassName}>{t9}{t12}</div>;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== creditCardOffer || $[29] !== ctaAnalytics || $[30] !== initiallyExpandedAccordion) {
    t14 = <div data-testid="product-card-redesign-product-content"><Accordions creditCardOffer={creditCardOffer} initiallyExpanded={initiallyExpandedAccordion} analytics={ctaAnalytics} segmentActionNamePrefix="card_redesign" actionSection="roundup_recommendations" /></div>;
    $[28] = creditCardOffer;
    $[29] = ctaAnalytics;
    $[30] = initiallyExpandedAccordion;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== skuViewedProps || $[33] !== t13 || $[34] !== t14 || $[35] !== t8) {
    t15 = <ProductCardAnalyticsWrapper skuViewedProps={skuViewedProps} wrapperProps={t8}>{t13}{t14}</ProductCardAnalyticsWrapper>;
    $[32] = skuViewedProps;
    $[33] = t13;
    $[34] = t14;
    $[35] = t8;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};